import LocalStorageHelper from "./LocalStorageHelper";

const ROICache = {

};
ROICache.CACHE_DEFAULT = "{ \"last_updated\": -1, \"geojson\": \"\" }";
ROICache.put = (roiModel) => {
	const key = "roi_" + roiModel.id;
	LocalStorageHelper.set(key, JSON.stringify({
		last_updated: roiModel.lastUpdated,
		geojson: roiModel.geojson
	}));
};
ROICache.get = (roiModel) => {
	const key = "roi_" + roiModel.id;
	const cachedROI = JSON.parse(LocalStorageHelper.get(key, ROICache.CACHE_DEFAULT));
	return cachedROI;
};
ROICache.requiresUpdating = (roiModel) => {
	const key = "roi_" + roiModel.id;
	if (!LocalStorageHelper.has(key)) {
		return true;
	}
	const cachedROI = JSON.parse(LocalStorageHelper.get(key, ROICache.CACHE_DEFAULT));
	if (roiModel.lastUpdated !== cachedROI.last_updated || cachedROI.geojson === "") {
		return true;
	}
	return false;
};
ROICache.updateFromServer = () => {
	// Look at what timestamps are in the AuthStore / localstore
};
export default ROICache;
